import { FC, PropsWithChildren } from "react";

import { Stack } from "@mui/material";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
import { FormTypography } from "@/forms-design-system/FormTypography";

type Props = PropsWithChildren<{
  title: string;
  isGhostPreview?: boolean;
  dataTest?: string;
}>;

export const SectionWrapper: FC<Props> = ({ title, children, isGhostPreview, dataTest }) => {
  return (
    <Stack
      gap={2}
      sx={{ ...(isGhostPreview && { opacity: GHOST_PREVIEW_OPACITY }) }}
      {...(dataTest && { "data-test": dataTest })}
    >
      <FormTypography variant="h6" vibe="intense">
        {title}
      </FormTypography>
      {children}
    </Stack>
  );
};
